module.exports = __webpack_public_path__ + "static/5d-7eefe2d4f785af5fdff2c1bcea07cd39.jpg";